import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Features } from "@/components/landing/Features";
import { ProductShowcase } from "@/components/landing/ProductShowcase";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Stats } from "@/components/landing/Stats";
import { FAQSection } from "@/components/landing/FAQSection";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import LogoLab from "@/pages/LogoLab";
import AdminLeads from "@/pages/AdminLeads";

const Landing = () => {
  return (
    <div className="bg-white text-zinc-950">
      <Navbar />
      <main>
        <Hero />
        <Features />
        <ProductShowcase />
        <HowItWorks />
        <Stats />
        <FAQSection />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/logo-lab" element={<LogoLab />} />
          <Route path="/admin" element={<AdminLeads />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
}

export default App;
